import React from "react"
import NavbarTwo from "./NavbarTwo"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import CookieBar from "./CookieBar"

const Layout = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleSidebar = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <NavbarTwo toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
      {children}
      <Footer />
      <CookieBar />
    </>
  )
}

export default Layout
